import {
  LOAD_POPULAR_CONTENT,
  LOAD_NEW_CONTENT,
  LOAD_NEW_CONTENT_SUCCESS,
  LOAD_POPULAR_CONTENT_SUCCESS,
  LOAD_SEARCH_CONTENT,
  LOAD_SEARCH_CONTENT_SUCCESS,
} from './constants';

export function loadNewContent(page, role, lang) {
  return {
    type: LOAD_NEW_CONTENT,
    payload: {
      page,
      role,
      lang: lang || 'ja',
    },
  };
}

export function saveLoadedNewContent(
  templates,
  total,
  currentPage,
  numberPages,
) {
  return {
    type: LOAD_NEW_CONTENT_SUCCESS,
    payload: {
      templates,
      total,
      currentPage,
      numberPages,
    },
  };
}

export function loadPopularContent(page) {
  return {
    type: LOAD_POPULAR_CONTENT,
    payload: {
      page,
    },
  };
}

export function saveLoadedPopularContent(
  templates,
  total,
  currentPage,
  numberPages,
) {
  return {
    type: LOAD_POPULAR_CONTENT_SUCCESS,
    payload: {
      templates,
      total,
      currentPage,
      numberPages,
    },
  };
}

export function loadSearchContent(keyword, page) {
  return {
    type: LOAD_SEARCH_CONTENT,
    payload: {
      keyword,
      page,
    },
  };
}

export function saveLoadedSearchContent(
  templates,
  total,
  currentPage,
  numberPages,
) {
  return {
    type: LOAD_SEARCH_CONTENT_SUCCESS,
    payload: {
      templates,
      total,
      currentPage,
      numberPages,
    },
  };
}
